import { 
	// USER
	UPDATE_USER,
	DELETE_USER,
	// DASHBOARD
	UPDATE_BOOKINGS,
	ADD_RESERVATION,
	ADD_LOCATION,
	ADD_UNIT,
	ADD_PROTECTION,
	// PAYMENT
	RESET_PAYMENT,
	SET_PAYMENT_PAGE_INDEX,
	ADD_PAYMENT_PAGE,
	SET_PAYMENT_LOCATION,
	SET_PAYMENT_RESERVATION,
	SET_PAYMENT_MOVEIN,
	SET_PAYMENT_DISCOUNT,
	SET_PAYMENT_DISCOUNT_ID,
	SET_PAYMENT_DIRECT_BOOKING,
	SET_PAYMENT_UNIT_SELECTION,
	ADD_PAYMENT_UNIT_INFO,
	SET_PAYMENT_CARD_INFO,
	SET_PAYMENT_ENCRYPTED_CARD_INFO,
	SET_PAYMENT_SIZE_SUGGESTIONS,
	SET_PAYMENT_AMENITY_SUGGESTIONS,
	ADD_PAYMENT_RETAIL,
	CLEAR_PAYMENT_RETAIL,
	SET_PAYMENT_RETAIL,
	ADD_PAYMENT_INSURANCE,
	CLEAR_PAYMENT_INSURANCE,
	SET_PAYMENT_INSURANCE,
	// META
	SET_POPUP_RECORD,
	SET_ADMIN_LOCATION
} from './actionTypes'


//
// USER
//
export const handleUserLogin = (payload) => {
	return {
		type: UPDATE_USER,
		payload
	}
}
export const handleUserLogout = (payload) => {
	return {
		type: DELETE_USER
	}
}


//
// DASHBOARD
//
export const updateBookings = (payload) => {
	return {
		type: UPDATE_BOOKINGS,
		payload
	}
}
export const addLocation = (payload) => {
	return {
		type: ADD_LOCATION,
		payload
	}
}
export const addReservation = (payload) => {
	return {
		type: ADD_RESERVATION,
		payload
	}
}
export const addUnit = (payload) => {
	return {
		type: ADD_UNIT,
		payload
	}
}
export const addProtection = (payload) => {
	return {
		type: ADD_PROTECTION,
		payload
	}
}


//
// PAYMENT
//
export const resetPayment = () => {
	return {
		type: RESET_PAYMENT
	}
}
export const setPaymentPageIndex = (newPageIndex) => {
	return {
		type: SET_PAYMENT_PAGE_INDEX,
		payload: newPageIndex
	}
}
export const addPaymentPage = (newPage) => {
	return {
		type: ADD_PAYMENT_PAGE,
		payload: newPage
	}
}
export const setPaymentLocation = (location) => {
	return {
		type: SET_PAYMENT_LOCATION,
		payload: location
	}
}
export const setPaymentReservation = (reservation) => {
	return {
		type: SET_PAYMENT_RESERVATION,
		payload: reservation
	}
}
export const setPaymentMoveIn = (moveIn) => {
	return {
		type: SET_PAYMENT_MOVEIN,
		payload: moveIn
	}
}
export const setPaymentDiscount = (discount) => {
	return {
		type: SET_PAYMENT_DISCOUNT,
		payload: discount
	}
}
export const setPaymentDiscountId = (discount) => {
	return {
		type: SET_PAYMENT_DISCOUNT_ID,
		payload: discount
	}
}
export const setPaymentDirectBooking = (directBooking) => {
	return {
		type: SET_PAYMENT_DIRECT_BOOKING,
		payload: directBooking
	}
}
export const setPaymentUnitSelection = (type, unit) => {
	return {
		type: SET_PAYMENT_UNIT_SELECTION,
		payload: { type, unit }
	}
}
export const addPaymentUnitInfo = (unitInfo) => {
	return {
		type: ADD_PAYMENT_UNIT_INFO,
		payload: unitInfo
	}
}
export const setPaymentCardInfo = (cardInfo) => {
	return {
		type: SET_PAYMENT_CARD_INFO,
		payload: cardInfo
	}
}
export const setPaymentEncryptedCardInfo = (encryptedCardInfo) => {
	return {
		type: SET_PAYMENT_ENCRYPTED_CARD_INFO,
		payload: encryptedCardInfo
	}
}
export const setPaymentSizeSuggestions = (suggestions) => {
	return {
		type: SET_PAYMENT_SIZE_SUGGESTIONS,
		payload: suggestions
	}
}
export const setPaymentAmenitySuggestions = (suggestions) => {
	return {
		type: SET_PAYMENT_AMENITY_SUGGESTIONS,
		payload: suggestions
	}
}
export const addPaymentRetail = (retail) => {
	return {
		type: ADD_PAYMENT_RETAIL,
		payload: retail
	}
}
export const clearPaymentRetail = () => {
	return {
		type: CLEAR_PAYMENT_RETAIL
	}
}
export const setPaymentRetail = (retail, quantity) => {
	return {
		type: SET_PAYMENT_RETAIL,
		payload: { retail, quantity }
	}
}
export const addPaymentInsurance = (insurance) => {
	return {
		type: ADD_PAYMENT_INSURANCE,
		payload: insurance
	}
}
export const clearPaymentInsurance = () => {
	return {
		type: CLEAR_PAYMENT_INSURANCE
	}
}
export const setPaymentInsurance = (insurance) => {
	return {
		type: SET_PAYMENT_INSURANCE,
		payload: insurance
	}
}


//
// META
//
export const setPopupRecord = (id, to) => {
	return {
		type: SET_POPUP_RECORD,
		payload: {
			id,
			to
		}
	}
}
export const setAdminLocation = (newLocation) => {
	return {
		type: SET_ADMIN_LOCATION,
		payload: newLocation
	}
}
